import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShoppingBag"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.5697 8.5125C21.4272 8.3459 21.2189 8.24999 20.9997 8.25H16.4997V5.25C16.4997 4.00736 15.4924 3 14.2497 3H9.74971C8.50707 3 7.49971 4.00736 7.49971 5.25V8.25H2.99971C2.77968 8.24751 2.56965 8.34177 2.42526 8.50782C2.28087 8.67387 2.21669 8.89495 2.24971 9.1125L3.65971 18.225C3.77186 18.9646 4.41174 19.5085 5.15971 19.5H18.8547C19.6027 19.5085 20.2426 18.9646 20.3547 18.225L21.7497 9.1125C21.7801 8.89582 21.7144 8.67667 21.5697 8.5125ZM8.99961 5.25C8.99961 4.83579 9.3354 4.5 9.74961 4.5H14.2496C14.6638 4.5 14.9996 4.83579 14.9996 5.25V8.25H8.99961V5.25ZM18.8546 18H5.14463L3.87713 9.75H20.1221L18.8546 18Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShoppingBag.vue"]]);
